import StaticCard from '@/components/UI/StaticCard'
import { cn } from '@/lib/utils'
import React from 'react'

interface MetricOverviewProps {
  isLoading?: boolean
  data: Array<{
    title: string
    value: number
    type?: 'percent' | 'default'
    helperText?: string
    showChartIcon?: boolean
  }>
}

const MetricOverview: React.FC<MetricOverviewProps> = ({ isLoading, data }) => {
  return (
    <div
      className={cn(
        'tw-grid tw-grid-cols-2 tw-gap-2',
        data.length % 3 === 0 ? 'md:tw-grid-cols-3' : 'md:tw-grid-cols-4',
      )}
    >
      {data.map(item => (
        <StaticCard
          key={item.title}
          title={item.title}
          value={item.value}
          type={item.type === 'percent' ? 'percent' : 'default'}
          helperText={item.helperText}
          showChartIcon={item.showChartIcon}
          isLoading={isLoading}
        />
      ))}
    </div>
  )
}

export default MetricOverview
